<script setup lang="ts">
import { HashtagsInput, NoteComponent } from '@metapic-apps/shared'

import { MAX_MONITORED_CREATORS } from '@/lib/constants/campaign.constants'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import { BoxComponent, TitleComponent, TypographyComponent } from '@/ui-library'

defineProps<{
  disabled?: boolean
  showMonitoringLimitNote?: boolean
}>()

const hashtags = defineModel<CampaignFormType['hashtags']>('hashtags', { default: () => [] })
</script>
<template>
  <el-form-item prop="hashtags">
    <BoxComponent :w="'100%'">
      <BoxComponent :mb="8">
        <TitleComponent title="Fetch content from hashtags">
          <template #tooltip>
            <BoxComponent :w="280">
              <BoxComponent :mb="4">
                <TypographyComponent variant="title-medium">Fetch from hashtags</TypographyComponent>
              </BoxComponent>
              <TypographyComponent variant="body-medium">
                Content with these hashtags is automatically fetched - but only from creators in this campaign.
                <br />
                Note: adding hashtags requires the campaign to end on an event.
              </TypographyComponent>
            </BoxComponent>
          </template>
        </TitleComponent>
      </BoxComponent>
      <HashtagsInput v-model="hashtags" name="hashtags" :disabled="disabled" />
      <BoxComponent v-if="disabled" :mt="8">
        <NoteComponent> Not available for the campaigns without approval. </NoteComponent>
      </BoxComponent>
      <BoxComponent v-else-if="showMonitoringLimitNote" :mt="8">
        <NoteComponent> Only the first {{ MAX_MONITORED_CREATORS }} active creators will be monitored. </NoteComponent>
      </BoxComponent>
    </BoxComponent>
  </el-form-item>
</template>
